import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/main.scss";
import App from "app";
import "./app/libs/i18n";
import { registerServiceWorker } from "serviceWorker";
import "./app/libs/firebase";
import "./app/libs/sentry";
import { IsVelarApp } from "static/types";
import { Capacitor } from "@capacitor/core";
import { AppMetrica } from "capacitor-appmetrica-plugin";
import { StatusBar, Style } from "@capacitor/status-bar";
import { SplashScreen } from "@capacitor/splash-screen";

async function applyInsets() {
  // TOP: use StatusBar height (works even when visualViewport offsetTop is 0)
  try {
    const info = await StatusBar.getInfo();
    const top = (info as any).height ?? 0;
    document.documentElement.style.setProperty("--inset-top", `${top}px`);
  } catch {
    document.documentElement.style.setProperty("--inset-top", `0px`);
  }

  // BOTTOM: static 16px
  document.documentElement.style.setProperty("--inset-bottom", `16px`);
}

/**
 * Wait for 2 animation frames (ensures first paint happened)
 */
function afterFirstPaint(): Promise<void> {
  return new Promise((resolve) => {
    requestAnimationFrame(() => requestAnimationFrame(() => resolve()));
  });
}

if (IsVelarApp) {
  document.documentElement.setAttribute("data-velar", "true");
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(<App />);

if (Capacitor.isNativePlatform()) {
  (async () => {
    // Native-only init
    AppMetrica.activate({
      apiKey: "91b16bec-c8c9-4c25-b7a5-78958a25ba4d",
      logs: true,
    });

    try {
      await StatusBar.setOverlaysWebView({ overlay: true });
      await StatusBar.setStyle({ style: Style.Light });
      await StatusBar.show();

      await applyInsets();
    } catch (e) {
      console.log("StatusBar ERROR", e);
    }

    // Wait until React painted at least once, then hide splash
    await afterFirstPaint();

    // Hide Capacitor splash when the app is ready
    await SplashScreen.hide();
  })();
} else {
  // Web: ensure bottom inset is 0 for web
  document.documentElement.style.setProperty("--inset-bottom", `0px`);
}

registerServiceWorker();
